import CmlTarifIndex from "@/components/billing_cml/tarif/TarifIndex.vue";
import CmlTarifAdd from "@/components/billing_cml/tarif/TarifAdd.vue";
import CmlTarifDetail from "@/components/billing_cml/tarif/TarifDetail.vue";
import CmlTarifEdit from "@/components/billing_cml/tarif/TarifEdit.vue";

let routesTarifAccess= [
    {
        path: '',
        meta: {
          title: "CML List Tarif",
        },
        name: "CmlTarifIndex",
        component: CmlTarifIndex
    },
    {
        path: 'create',
        meta: {
          title: "CML Create Tarif",
        },
        name: "CmlTarifAdd",
        component: CmlTarifAdd
    },
     
    {
        path: 'detail/:id',
        meta: {
          title: "CML Detail Tarif",
        },
        name: "CmlTarifDetail",
        component: CmlTarifDetail
    },
     
    {
        path: 'edit/:id',
        meta: {
          title: "CML Edit Tarif",
        },
        name: "CmlTarifEdit",
        component: CmlTarifEdit
    },
    
]

export default routesTarifAccess
  